import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Table, Icon, Modal, Button, Pagination } from 'semantic-ui-react';
import Emoji from '../../Reusable/Emoji';
import { assetUrl } from '../../../utils/graphqlClient';

import ModifyEntry from './ModifyEntry';
/* import Pagination from './Pagination'; */

import './list.scss';

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      modalOpenVerifDelete: false,
      pictureData: [],
      idPictureToDelete: '',

      /* PAGINATION PART */
      boundaryRange: 1,
      siblingRange: 1,
      showEllipsis: true,
      showFirstAndLastNav: true,
      showPreviousAndNextNav: true,
      activePage: 1,
      offset: 0,
      /* END OF PAGINATION PART */

      column: null,
      direction: null,
      data: this.props.pictures
    };
  }

  componentDidUpdate (prevProps) {    
    if (this.props.pictures !== prevProps.pictures) {
      this.setState({
        data: this.props.pictures,
      })
    }
  }

          // Open/close picture edit modal
  handleOpen = (picData) => {
    this.setState({ 
      modalOpen: true,
      pictureData: picData,
    });
  };
  handleClose = () => {
    this.setState({ 
      modalOpen: false,
      pictureData: [],
    })
  };

  // Open/close picture delete confirmation modal
  handleOpenVerifDelete = (id) => {
    this.setState({ 
      modalOpenVerifDelete: true,
      idPictureToDelete: id,
    });
  };
  handleCloseVerifDelete = () => {
    this.setState({ 
      modalOpenVerifDelete: false,
      idPictureToDelete: '',
    })
  };

  handleDeletePic = () => {
    this.props.onDelete(this.state.idPictureToDelete);
    this.handleCloseVerifDelete();
  }

  handlePaginationChange = (e, { activePage }) => this.setState({ 
    activePage, 
    offset: (activePage - 1) * this.props.perPage,
  })

  handleSort = (clickedColumn) => () => {
    const { column, direction, data } = this.state
    
    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(this.props.pictures, [clickedColumn]),
        direction: 'ascending',
      })
      return
    }
    this.setState({
      data: data.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handleStarredClick = (data) => {
    this.props.handleStarred(data.id, data.isStarred)
  }

  handlePublicationClick = (data) => {
    this.props.handlePublication(data.id, data.isPublished);
  }

  render() {
    
    const {
      labels,
      perPage,
      totalPages,
    } = this.props;

    const {
      /* PAGINATION PART */
      activePage,
      boundaryRange,
      siblingRange,
      showEllipsis,
      showFirstAndLastNav,
      showPreviousAndNextNav,
      offset,
      /* PAGINATION PART */

      column,
      data,
      direction,
    } = this.state;

    const picturesToShow = data.slice(offset, (offset + perPage))    

    return (
      <>
        <div id="list">
          <h2 className="list-title">Picture's List</h2>
          <Table sortable celled unstackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell 
                  textAlign="center"
                  sorted={column === 'id' ? direction : null}
                  onClick={this.handleSort('id')}
                >
                  Id
                </Table.HeaderCell>
                <Table.HeaderCell
                  sorted={column === 'name' ? direction : null}
                  onClick={this.handleSort('name')}
                >
                  Name
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Thumb</Table.HeaderCell>
                <Table.HeaderCell
                  sorted={column === 'place' ? direction : null}
                  onClick={this.handleSort('place')}
                >
                  Place
                </Table.HeaderCell>
                <Table.HeaderCell
                  sorted={column === 'labelId' ? direction : null}
                  onClick={this.handleSort('labelId')}
                >
                  Label
                </Table.HeaderCell>
                <Table.HeaderCell 
                  textAlign="center"
                  sorted={column === 'isStarred' ? direction : null}
                  onClick={this.handleSort('isStarred')}
                >
                  <Icon name="star" />
                </Table.HeaderCell>
                <Table.HeaderCell 
                  textAlign="center"
                  sorted={column === 'likes' ? direction : null}
                  onClick={this.handleSort('likes')}
                >
                  <Icon name="heart" />
                </Table.HeaderCell>
                <Table.HeaderCell
                  textAlign="center"
                  sorted={column === 'isPublished' ? direction : null}
                  onClick={this.handleSort('isPublished')}
                >
                  <Icon name="world" />
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center"><Icon name="trash alternate" /></Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body className="table-body">
              {picturesToShow.map((picture) => (
                <Table.Row key={picture.id}>
                  <Table.Cell textAlign="center">{picture.id}</Table.Cell>
                  <Table.Cell selectable onClick={() => {this.handleOpen({...picture})}}>{picture.name}</Table.Cell>
                  <Table.Cell textAlign="center">
                    {picture.thumb ? (
                      <img
                        src={assetUrl(`uploads/${picture.thumb}`)}
                        alt={picture.name}
                        style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: 4 }}
                      />
                    ) : (
                      '-'
                    )}
                  </Table.Cell>
                  <Table.Cell>{picture.place}</Table.Cell>
                  <Table.Cell>
                    {labels.map((label) => {                      
                      if (label.id === picture.labelId) { return label.name }
                    })}
                  </Table.Cell>
                  <Table.Cell textAlign="center" selectable onClick={() => {this.handleStarredClick({...picture})}}>
                    {picture.isStarred ? <Icon className="full" name="star" /> : <Icon name="star outline" />}
                  </Table.Cell>
                  <Table.Cell textAlign="center">{picture.likes}</Table.Cell>
                  <Table.Cell textAlign="center" selectable onClick={() => {this.handlePublicationClick({...picture})}}>
                    {picture.isPublished ? <Icon color="green" name="eye" /> : <Icon color="grey" name="eye slash" />}
                  </Table.Cell>
                  <Table.Cell textAlign="center"><Icon link name="trash" onClick={() => {this.handleOpenVerifDelete(picture.id)}} /></Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>

          <Pagination
            activePage={activePage}
            boundaryRange={boundaryRange}
            onPageChange={this.handlePaginationChange}
            size='mini'
            siblingRange={siblingRange}
            totalPages={totalPages}
            // Heads up! All items are powered by shorthands, if you want to hide one of them, just pass `null` as value
            ellipsisItem={showEllipsis ? undefined : null}
            firstItem={showFirstAndLastNav ? undefined : null}
            lastItem={showFirstAndLastNav ? undefined : null}
            prevItem={showPreviousAndNextNav ? undefined : null}
            nextItem={showPreviousAndNextNav ? undefined : null}
          />

          <Modal
            open={this.state.modalOpen}
            onClose={this.handleClose}
          >
            <Modal.Header>Edit picture: {this.state.pictureData.name}</Modal.Header>
            <Modal.Content image>
              <Modal.Description>
                <ModifyEntry picture={this.state.pictureData} labels={this.props.labels} onSubmit={this.props.onModify} />
              </Modal.Description>
            </Modal.Content>
          </Modal>

          <Modal size="tiny" open={this.state.modalOpenVerifDelete} onClose={this.handleCloseVerifDelete}>
            <Modal.Header>Delete This Picture</Modal.Header>
            <Modal.Content>
              <p>Are you sure you want to delete this nice fucking picture ?</p>
            </Modal.Content>
            <Modal.Actions>
              <Button size='tiny' className="customNeg" negative onClick={this.handleCloseVerifDelete}>
                No, No, Nooo
                <Emoji emoji='scream' set='google' size={24} />
              </Button>
              <Button size='tiny' positive onClick={this.handleDeletePic}>
                Hell Yeah
                <Emoji emoji='the_horns' set='google' size={24} />
              </Button>
            </Modal.Actions>
          </Modal>
        </div>
      </>
    );
  }
  
};

List.propTypes = {
  labels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  pictures: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      place: PropTypes.string,
      description: PropTypes.string,
      customClass: PropTypes.string,
      src: PropTypes.string,
      thumb: PropTypes.string,
      labelId: PropTypes.number,
      isPublished: PropTypes.bool,
    }).isRequired,
  ).isRequired,
  handleStarred: PropTypes.func.isRequired,
  handlePublication: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onModify: PropTypes.func.isRequired,
};

export default List;
